import { render } from "./CascaderPanel.vue?vue&type=template&id=b7ea466e"
import script from "./CascaderPanel.vue?vue&type=script&lang=js"
export * from "./CascaderPanel.vue?vue&type=script&lang=js"
script.render = render

export default script